var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUserOutlineEmotionsSad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.25 2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,11A11,11,0,1,1,11,22,11.012,11.012,0,0,1,0,11Zm2.2,0A8.8,8.8,0,1,0,11,2.2,8.811,8.811,0,0,0,2.2,11ZM14.52,14.96a4.655,4.655,0,0,0-.937-.87,4.2,4.2,0,0,0-5.168,0,4.614,4.614,0,0,0-.936.87,1.1,1.1,0,0,1-1.76-1.32,6.73,6.73,0,0,1,1.4-1.33,6.393,6.393,0,0,1,7.757,0,6.72,6.72,0,0,1,1.4,1.33,1.1,1.1,0,1,1-1.759,1.32Z",
    transform: "translate(-0.25 -0.25)",
    fill: "#ff5050"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserOutlineEmotionsSad);
export default __webpack_public_path__ + "static/media/Icon-User-Outline-Emotions-Sad.c43f998efc96687adae1b8de85d3be31.svg";
export { ForwardRef as ReactComponent };